module.exports = __webpack_public_path__ + "img/arrow-right-black.3a472110.svg";